import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> { }

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    // py-1, NOT py-2. The height is fixed at --input-height (2rem = 32px) and
                    // the text is 14px on a 20px line, so 8px of padding either side leaves a
                    // content box of 32 - 2 border - 16 padding = 14px for a 20px line. The line
                    // does not fit, and Chrome centres the overflow, so the text sits in a box
                    // it is 6px too tall for — which is why it reads as not quite centred,
                    // especially with password dots, whose glyphs sit at the em middle rather
                    // than on the baseline. 4px leaves 22px, and the line fits.
                    //
                    // py-2 came from the shadcn default, which assumes h-10 (40px). The height
                    // was reduced here without reducing the padding to match.
                    "flex h-[var(--input-height)] w-full rounded-md border border-input bg-background px-3 py-1 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
                    className
                )}
                ref={ref}
                {...props}
            />
        )
    }
)
Input.displayName = "Input"

export { Input }





